import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from 'app/pages/LoginPage/slice';

const selectDomain = (state: RootState) =>
  state.conventionalLogin || initialState;

export const selectConventionalLogin = createSelector(
  [selectDomain],
  conventionalLoginState => conventionalLoginState,
);

export const selectLogin = createSelector(
  [selectDomain],
  loginState => loginState.login,
);

export const selectRoutes = createSelector(
  [selectDomain],
  loginState => loginState.routes,
);